import React, { useMemo } from 'react'
import moment from 'moment'
import { View } from 'react-native'
import { Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { SHORT_MONTH_AND_DATE_FORMAT } from '@src/config/momentFormat'

interface CalendarIconProps {
  variant: 'plus' | 'check' | 'date'
  date?: string
}

export const CalendarIcon = ({ variant, date }: CalendarIconProps) => {
  const styles = useStyleSheet(themedStyles)
  const { month, day } = useMemo(() => {
    if (!date) {
      return {}
    }
    const [month, day] = moment(date).format(SHORT_MONTH_AND_DATE_FORMAT).split(' ')

    return { month, day }
  }, [date])

  return (
    <View style={styles.container}>
      <View style={[styles.band, variant === 'date' && styles.bandTall]}>
        {variant === 'date' && !!month && (
          <Text type="title-3" style={styles.month}>
            {month}
          </Text>
        )}
      </View>
      <View style={styles.content}>
        {variant === 'date' ? (
          <Text type="title-2">{day}</Text>
        ) : (
          <Icon name={variant} size={32} style={styles.icon} weight="bold" />
        )}
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
  },
  band: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    width: 64,
    backgroundColor: 'theme.barChart.primary',
  },
  bandTall: {
    height: 28,
  },
  month: {
    top: 2,
    color: 'theme.solid.white',
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'theme.background',
  },
  icon: {
    color: 'theme.barChart.primary',
  },
})
